/* eslint-disable react-hooks/exhaustive-deps */
import GuideTooltip from "@/components/GuideTooltip";
import useAppStore from "@/context/store";
import { ThirdLoginMode, useThirdLogin } from "@/utils/hooks/useThirdLogin";
import { MSG_TYPE, postMessageToParent } from "@/utils/postMessageToParent";
import { useMemoizedFn } from "ahooks";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import HBIcon from "../../HBIcon";
import styles from "../index.module.less";
import { isDestoryingAccount, openDestoryAccountInfo } from "../loginErrHandle";

const isClient = typeof window !== "undefined";
/**
 * 第三方登录
 */
export default function Third({ isRegister, onOk }) {
  return (
    <div className={styles.other}>
      <div className={styles.desc}>其他方式{isRegister ? "注册" : "登录"}</div>
      <ThirdLogin onOk={onOk} />
    </div>
  );
}

/**
 *
 * @param {{
 *  onOk: (user: IUser) => void
 *  tooltipProps?: import("antd").TooltipProps
 * }} props
 * @returns
 */
export function ThirdLogin({ onOk, tooltipProps = {} }) {
  const { onThirdLogin: login } = useThirdLogin({
    onOk,
    mode: ThirdLoginMode.login,
  });

  const [visible, setVisible] = useState(false);

  const currentTypeRef = useRef(null);
  const onThirdClick = useMemoizedFn(async (type) => {
    setVisible(true);
    currentTypeRef.current = type;
  });

  const onTooltipClose = useMemoizedFn(() => {
    setVisible(false);
  });

  const onTooltipAction = useMemoizedFn(() => {
    setVisible(false);
    login(currentTypeRef.current);
  });

  const [placement, setPlacement] = useState("right");

  // 根据当前屏幕宽度设置GuideTooltip的位置
  useEffect(() => {
    if (window.innerWidth < 768) {
      setPlacement("top");
    }
  }, []);

  return (
    <div className={styles.thirdLoginList}>
      <div
        className={classNames([styles.thirdLoginItem, styles.qq])}
        data-gd-click="button_click"
        data-button-name="QQ登录注册"
        onClick={() => {
          login("qzone");
        }}
      >
        <HBIcon className={styles.icon} type="ic_qq1" title="QQ" />
      </div>
      <GuideTooltip
        color="#298DFF"
        title={"温馨提示"}
        content="我们将于近期下线微博、豆瓣登录方式,请你绑定手机号, 届时使用手机号进行登录"
        visible={visible}
        className={styles.tooltip}
        getPopupContainer={() => document.body}
        placement={placement}
        width={280}
        actionText="我知道了，去授权"
        onClose={onTooltipClose}
        onAction={onTooltipAction}
        {...tooltipProps}
      >
        <div
          className={classNames([styles.thirdLoginItem, styles.weibo])}
          data-gd-click="button_click"
          data-button-name="微博登录注册"
          onClick={() => {
            onThirdClick("weibo");
          }}
        >
          <HBIcon className={styles.icon} type="ic_xl1" title="微博" />
        </div>
        <div
          className={classNames([styles.thirdLoginItem, styles.douban])}
          data-gd-click="button_click"
          data-button-name="豆瓣登录注册"
          onClick={() => {
            onThirdClick("douban");
          }}
        >
          <HBIcon className={styles.icon} type="ic_db" title="豆瓣" />
        </div>
      </GuideTooltip>
    </div>
  );
}

export function thirdLoginOK() {
  // 第三方登录过来的改变登录状态
  if (isClient) {
    postMessageToParent(MSG_TYPE.thirdLoginOk, {
      // 标识当前iframe环境，微信一般是Iframe，其他为小窗
      isIframe: window.self !== window.top,
    });
    return true;
  }
  return false;
}

export function thirdLoginLoading() {
  if (isClient) {
    // 改变状态
    localStorage.setItem("third_login", "loading");
  }
}

export function thirdLoginRegisterOk() {
  if (isClient) {
    postMessageToParent(MSG_TYPE.thirdLoginOk, {
      isRegister: true,
    });
  }
}

export async function onThirdLoginOk(e) {
  if (e.data.type === MSG_TYPE.thirdLoginOk) {
    // 微信的iframe嵌套页面message消息，不做响应
    if (e.data.isIframe) {
      return;
    }

    useAppStore.getState().refreshUser();

    window.removeEventListener("message", onThirdLoginOk);
  } else if (e.data.type === MSG_TYPE.thirdLoginFail) {
    if (isDestoryingAccount(e.data)) {
      openDestoryAccountInfo();
    }

    window.removeEventListener("message", onThirdLoginOk);
  }
}
